module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0107.jpg?v=91fbc936";